import ListCandidateOffer from './ListCandidateOffer';

export default ListCandidateOffer

